<script>
  import ImpactInvestment from "../Icons/ImpactInvestment.svelte";
  import MissionDriven from "../Icons/MissionDriven.svelte";
  import Nonprofits from "../Icons/Nonprofits.svelte";
  import PolicyGovernment from "../Icons/PolicyGovernment.svelte";

  import { fly } from "svelte/transition";
  export let item;
  export let mobile = false;

  const componentLookup = {
    "Nonprofits & institutions": Nonprofits,
    "Impact investment": ImpactInvestment,
    "Mission-driven company": MissionDriven,
    "Policy & government": PolicyGovernment,
  };

  $: xPos = mobile ? 0 : 100;
  $: yPos = mobile ? 100 : 0;

  import { selectedType } from "../../stores/global.js";

  const setActive = function (title) {
    selectedType.set(title == $selectedType ? null : title);
  };
</script>

<div
  class="key-item {mobile ? 'mobile' : 'desktop'}
                  {$selectedType
    ? $selectedType == item.title
      ? 'active'
      : 'inactive'
    : ''}"
  in:fly={{ x: xPos, y: yPos, duration: 400 }}
  on:click={setActive(item.title)}
>
  <div class="key-item-title-container">
    <svelte:component this={componentLookup[item.title]} size="25" />
    <span class="key-item-title">{item.title}</span>
  </div>
  <p class="key-item-description">
    {item.description}
  </p>
</div>

<style>
  .key-item {
    cursor: pointer;
    transition: all 300ms ease;
    width: 100%;
    flex-direction: column;
    justify-content: space-evenly;
    display: flex;
    padding: 12px;
  }

  .key-item-title-container {
    display: flex;
    place-items: center;
    height: 30px;
    margin-bottom: 6px;
  }

  .mobile .key-item-title-container {
    height: 25px;
  }

  .mobile .key-item-title {
    font-size: 1.75rem;
  }

  .mobile .key-item-description {
    font-size: 0.85rem;
  }

  .key-item-title {
    font-size: 2rem;
    font-family: var(--font-big);
    letter-spacing: 0.64px;
    text-transform: uppercase;
    margin-left: 5px;
    transform: scaleY(0.9);
  }

  .key-item-description {
    font-size: 0.9rem;
    font-family: var(--font-small);
    font-weight: 200;
    line-height: 1.1;
  }

  .key-item.desktop:nth-child(2),
  .key-item.desktop:nth-child(4) {
    border-right: 1px solid rgba(0, 0, 0, 0.2);
  }

  .key-item.desktop:nth-child(2),
  .key-item.desktop:nth-child(3) {
    border-bottom: 1px solid rgba(0, 0, 0, 0.2);
  }

  .key-item.mobile:nth-child(1),
  .key-item.mobile:nth-child(2),
  .key-item.mobile:nth-child(3),
  .key-item.mobile:nth-child(4) {
    border-bottom: 1px solid rgba(0, 0, 0, 0.2);
  }

  :global(.key-item svg) {
    margin: 0;
  }

  .inactive {
    color: #cecece80;
  }
</style>
